import { isArray } from "ionic-angular/util/util";

export const isInArray = (value: any, array: Array<any>) => {

    if (!array || !isArray(array)) {
        console.warn("invalid value for array: ", array);
        return false;
    }

    return array.indexOf(value) !== -1;
};



// WEBPACK FOOTER //
// ./src/core/util/is-in-array.ts